<template>
  <v-form ref="form">
    <v-text-field label="Field Name" :rules="[rules.required]" v-model="formObject.Field" required :disabled="false && isUpdate" />

    <v-select @input="clearValue()" label="Field Value Type" :rules="[rules.required]" :items="fieldTypeItems" v-model="fieldType" item-text="text" item-value="value" required :disabled="false && isUpdate" />


    <v-menu v-if="fieldType == METADATA_FIELD_TYPES.datetime.value" :rules="[rules.required]" :close-on-content-click="false" v-model="dateMenu" transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px" min-width="290px">
      <v-text-field slot="activator" label="Field Value" v-model="prettyDateValue" readonly prepend-inner-icon="event" />
      <v-date-picker v-model="formObject.FieldValue" no-title scrollable actions @input="dateMenu = false" />
    </v-menu>
    <v-text-field v-else-if="fieldType == METADATA_FIELD_TYPES.string.value" :rules="[rules.required]" label="Field Value" v-model="formObject.FieldValue" required />
    <v-text-field v-else-if="fieldType == METADATA_FIELD_TYPES.number.value" :rules="[rules.required]" label="Field Value" v-model.number="formObject.FieldValue" type="number" required />

    <v-select label="Ordinal In The List" :rules="[rules.required]" :items="ordinalInTheList" v-model="formObject.Ordinal" required />
  </v-form>
</template>

<script>
  import moment from 'moment'

  import {
    METADATA_FIELD_TYPES,
  } from '@/helpers/metadata'

  import {
    prettyDateFormat,
  } from '@/components/mixins/MomentUtil'

  export default {
    props: {
      station: Object,
      metadata: Array,
    },
    data: () => ({
      METADATA_FIELD_TYPES,
      initialObject: {
        Field: null,
        FieldValue: null,
        FieldType: METADATA_FIELD_TYPES.string.value,
        Ordinal: null,
      },
      formObject: {},
      fieldTypeItems: Object.values(METADATA_FIELD_TYPES),
      dateMenu: false,
      rules: {
        required: (v) => !!v || 'Required.',
      },
      isUpdate: false,
    }),
    computed: {
      ordinalInTheList: function() {
        if (!this.metadata) return []
        return [...Array(this.metadata.length + 1).keys()].map(x => x + 1)
      },
      prettyDateValue() {
        let date = this.formObject.FieldValue
        if (!date) return null
        return moment(date).format(prettyDateFormat)
      },
      payload() {
        return {
          StationId: this.station.Id,
          ...this.formObject,
        }
      },
      fieldType: {
        get() {
          return this.formObject && this.formObject.FieldType && this.formObject.FieldType.toLowerCase()
        },
        set(value) {
          this.formObject.FieldType = value
        },
      },
    },
    methods: {
      initialize(data) {
        if (data) {
          this.formObject = JSON.parse(JSON.stringify(data))
          this.isUpdate = true
        } else {
          this.formObject = JSON.parse(JSON.stringify(this.initialObject))
          this.formObject.Ordinal = this.ordinalInTheList && this.ordinalInTheList[0]
          this.isUpdate = false
        }

        this.$refs.form.resetValidation()
      },
      clearValue() {
        this.formObject.FieldValue = null
      },
      validate() {
        return this.$refs.form.validate()
      },
    },
  }
</script>